import React from "react";
import "./FooterMarquee.css";

const FooterMarquee = () => {
  const marqueeText =
    "WELCOME :-) FOUNDED IN 2026, DID YOU KNOW? IRONCLAD ANTIVIRUS INCLUDES: ADVANCED QUARANTINE MANAGEMENT, DETAILED SCAN LOGS, REAL-TIME STATUS UPDATES WITHIN THE GUI, HEURISTIC AND FOUNDATIONAL BEHAVIORAL DETECTION, SUSPICIOUS PROCESS MONITORING, AND COMPREHENSIVE FILE AND FOLDER SCANNING.";

  return (
    <footer className="footer-marquee">
      <div className="footer-line" />

      <div className="marquee-container">
        <div className="marquee">
          <span>{marqueeText}</span>
          <span>{marqueeText}</span>
        </div>
      </div>
    </footer>
  );
};

export default FooterMarquee;
